import axios from "axios";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: (url, payload, header) => {
    return axios.get(url, payload, header);
  },
};
